import ContactHero from "../components/contact/ContactHero";
import ContactInfo from "../components/contact/ContactInfo";
import ContactForm from "../components/contact/ContactForm";

const Contact = () => {
  return (
    <>
      <ContactHero />

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-12">

          {/* Left */}
          <div>
            <h2 className="text-3xl font-bold text-gray-900 mb-8">
              Need more information? <br/>Get In Touch with us
            </h2>

            <ContactInfo />
          </div>

          {/* Right */}
          <ContactForm />

        </div>
      </section>
    </>
  );
};

export default Contact;